import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslations from "./locales/en.json";
import ruTranslations from "./locales/ru.json";
import zhTranslations from "./locales/zh.json";
import esTranslations from "./locales/es.json";

const resources = {
  en: { translation: enTranslations },
  ru: { translation: ruTranslations },
  zh: { translation: zhTranslations },
  es: { translation: esTranslations },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("language") || "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
